import { graphql, useStaticQuery } from "gatsby"
import PropTypes from "prop-types"
import React, { useCallback, useEffect, useState } from "react"
import { Helmet } from "react-helmet"

import RemoveFocusRingWhenNotTabbing from "@knowit-alma/common/src/components/atoms/RemoveFocusRingWhenNotTabbing/RemoveFocusRingWhenNotTabbing"
import useEventListener from "@knowit-alma/common/src/components/atoms/UseEventListener/UseEventListener"
import Footer from "@organisms/Footer/Footer"
import Header from "@organisms/Header/Header"

import "../styles/main.scss"

const Layout = ({
  children,
  location,
  layoutContext = "",
  customClass,
  currentLanguage = "fi",
}) => {
  // Navigation menu trigger
  const [open, setOpen] = useState(false)

  // Accessibility thing
  RemoveFocusRingWhenNotTabbing()

  // Selligent forms

  const selligentFormHandler = useCallback(({ data }) => {
    try {
      const eventData = JSON.parse(data)
      if (document && document.getElementById("formframe")) {
        if (eventData?.campaign === "sell-iframe" && eventData?.height) {
          const height = eventData.height
          document.getElementById("formframe").style.height = `${height}px`
          if (height < 300) {
            if (typeof window !== "undefined") {
              const formframe = document.getElementById("formframe")
              const headerOffset = 125
              const elementPosition = formframe.getBoundingClientRect().top
              const offsetPosition =
                elementPosition + window.pageYOffset - headerOffset

              window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
              })
            }
          }
        }
      }
    } catch (e) {
      //console.log("not selligent")
    }
  }, [])

  useEventListener("message", selligentFormHandler)

  useEffect(() => {
    if (document && document.getElementById("formframe")) {
      const formEmbedURL = document.getElementById("formframe").src
      document.getElementById("formframe").src = `${formEmbedURL}&init=1`
    }
  }, [])

  useEffect(() => {
    if (
      document &&
      document.getElementById(
        "alma-content-router-target-5577dbe2b922930e0c000022"
      )
    ) {
      const almaFooter = document.getElementById(
        "alma-content-router-target-5577dbe2b922930e0c000022"
      )
      almaFooter.style.visibility = open ? "hidden" : "visible"
      almaFooter.ariaHidden = open ? true : false
    }
    if (document && document.getElementById("formframe")) {
      const almaForm = document.getElementById("formframe")
      almaForm.style.visibility = open ? "hidden" : "visible"
      almaForm.style.display = open ? "none" : "block"
      almaForm.ariaHidden = open ? true : false
    }
  }, [open])

  const data = useStaticQuery(
    graphql`
      fragment KnowitMenuItems on WpMenuItem {
        id
        url
        path
        label
        cssClasses
        title
        parentId
        order
      }

      {
        wp {
          generalSettings {
            title
            url
          }
          defaultLanguage {
            name
            code
          }
          languages {
            name
            code
            slug
          }
          siteSettings {
            siteSettings {
              facebookUrl
              linkedinUrl
              twitterUrl
              postalAddress
              visitingAddress
              footerContentFi
              linkLogin {
                url
                title
                target
              }
              linkShop {
                url
                title
                target
              }
              loginLinks {
                icon {
                  sourceUrl
                }
                link {
                  target
                  title
                  url
                }
              }
            }
          }
        }

        menuFI: allWpMenuItem(
          filter: {
            locations: { eq: GATSBY_HEADER_MENU }
            parentId: { eq: null }
          }
          sort: { order: ASC }
        ) {
          edges {
            node {
              ...KnowitMenuItems
              childItems {
                nodes {
                  ...KnowitMenuItems
                  childItems {
                    nodes {
                      ...KnowitMenuItems
                    }
                  }
                }
              }
            }
          }
        }

        menuFooterFI: allWpMenuItem(
          filter: { locations: { eq: GATSBY_FOOTER_MENU } }
          sort: { order: ASC }
        ) {
          edges {
            node {
              ...KnowitMenuItems
            }
          }
        }
      }
    `
  )

  const { title, url } = data.wp.generalSettings
  const { siteSettings } = data.wp.siteSettings

  //const defaultLangCode = data.wp?.defaultLanguage?.code || "EN"
  const defaultLanguage = data.wp.defaultLanguage

  // 404
  if (typeof location === "undefined") {
    location = {
      pathname: "404",
    }
  }

  // Map menu items

  let items = {
    fi: [],
  }

  for (const [key] of Object.entries(items)) {
    let menu = "menu"
    menu = menu.concat(key.toUpperCase())
    items[key] = data[menu]?.edges.map((item) => {
      item.childItems = {}
      return {
        ...item.node,
        url: item.node.url.replace(url.replace("/wp", ""), ""),
      }
    })
  }

  let footerItems = {
    fi: [],
  }

  for (const [key] of Object.entries(footerItems)) {
    let menu = "menuFooter"
    menu = menu.concat(key.toUpperCase())
    footerItems[key] = data[menu]?.edges.map((item) => {
      item.childItems = {}
      return {
        ...item.node,
        url: item.node.url.replace(url.replace("/wp", ""), ""),
      }
    })
  }

  return (
    <>
      <Helmet
        htmlAttributes={{
          class: layoutContext,
        }}
      />
      <Header
        siteTitle={title}
        menuItems={items}
        siteSettings={siteSettings}
        defaultLanguage={defaultLanguage}
        currentLanguage={currentLanguage}
        open={open}
        setOpen={setOpen}
        customClass={open ? "nav-state--active" : ""}
      />
      <main
        aria-hidden={open}
        className={`${customClass} ${open ? "nav-state--active" : ""}`}
      >
        <div className="container">{children}</div>
      </main>
      <Footer
        siteTitle="Alma Insights"
        siteSettings={siteSettings}
        footerMenu={footerItems[currentLanguage]}
      />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  translations: PropTypes.array,
  currentLanguage: PropTypes.string,
}

export default Layout
